import React from "react";
import Header from "./Header";
import Third from "./Third/Third";
import Video from "./Video";
import Mindset from "./Mindset";
import Footer from "./Footer";
// import Quotes from "./Quotes";
const FinalPage = () => {
  return (
    <div>
      <Header />
      <Mindset />
      <Third />
      <Video />
      <Footer />

      {/* <Quotes /> */}
    </div>
  );
};

export default FinalPage;
